import {
  Component,
  Input,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

import { ContentDocumentLink } from 'src/app/models/content-document-link.model';
import { MatSelectChange } from '@angular/material/select';
import { Payment } from '../../../models/payment.model';

@Component({
    selector: 'app-billing-list',
    templateUrl: './billing-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BillingListComponent {
  @Input() payments: Payment[];

  @Input() isPaymentsLoading: boolean;

  @Input() isPaymentsLoaded: boolean;

  @Input() invoices: ContentDocumentLink[];

  @Input() isInvoicesLoading: boolean;

  @Input() isInvoicesLoaded: boolean;

  @Input() selectedInvoice: ContentDocumentLink;

  @Output() selectInvoice: EventEmitter<any> = new EventEmitter();

  @Output() downloadInvoice: EventEmitter<any> = new EventEmitter();

  @Output() changeInvoiceFilterSelection: EventEmitter<any> =
    new EventEmitter();

  @Output() changePaymentFilterSelection: EventEmitter<any> =
    new EventEmitter();

  filters = [
    { text: 'LAST 6', value: 6 },
    { text: 'LAST 12', value: 12 },
    { text: 'LAST 24', value: 24 },
  ];

  @Input() paymentSelectedFilter = 6;

  @Input() invoiceSelectedFilter = 6;

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    // Initialize arrays to prevent template errors
    this.payments = [];
    this.invoices = [];
  }

  onSelect($event: ContentDocumentLink): void {
    this.selectInvoice.emit($event);
    this.changeDetectorRef.detectChanges();
  }

  onDownload($event: ContentDocumentLink): void {
    this.downloadInvoice.emit($event);
  }

  onInvoiceFilterSelect(event: MatSelectChange): void {
    const size: number = Number(event.value);
    this.changeInvoiceFilterSelection.emit(size);
  }

  onPaymentFilterSelect(event: MatSelectChange): void {
    const size: number = Number(event.value);
    this.changePaymentFilterSelection.emit(size);
  }
}
